// Bucket `facturas` pasa a privado (tanda A2b de seguridad, 2026-09-26,
// supabase/migrations/20260926h_seguridad_a2b_storage.sql). `facturas_externas.archivo_url`
// guarda la URL con el molde de getPublicUrl (no se toca la base, 10.208) — para abrir el
// documento hay que reconstruir el path desde esa URL y firmarlo al momento del click (1h,
// requiere sesión `authenticated`).
import { client } from "./supabase";

const MARCADOR_PATH_PUBLICO = "/object/public/facturas/";

const extraerPathFactura = (archivoUrl) => {
  if (!archivoUrl) return null;
  const idx = archivoUrl.indexOf(MARCADOR_PATH_PUBLICO);
  if (idx === -1) return null;
  return archivoUrl.slice(idx + MARCADOR_PATH_PUBLICO.length);
};

export const abrirDocumentoFacturaExterna = async (archivoUrl) => {
  const path = extraerPathFactura(archivoUrl);
  if (!path) return { ok: false, error: "No se pudo determinar la ruta del archivo" };
  const { data, error } = await client.storage.from("facturas").createSignedUrl(path, 3600);
  if (error || !data?.signedUrl) return { ok: false, error: error?.message || "No se pudo firmar el documento" };
  window.open(data.signedUrl, "_blank", "noopener,noreferrer");
  return { ok: true };
};
